





































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import Toggle from '@/components/Toggle.vue';
import cloneDeep from 'lodash/cloneDeep';

@Component({
    components: {
        Toggle,
    },
    computed: {
        ...mapGetters({
            facility: 'SharedFacilities/getActiveAdminFacility',
            facilityPhotos: 'SharedFacilities/getActiveFacilityPhotos',
        }),
    },
})
export default class PreviewSharedFacilityForm extends Vue {
    public fullInfoVisibility: boolean = false;
    public availableForBooking: boolean = false;

    constructor() {
        super();
    }

    get activeFacility() {
        return this.$store.getters['SharedFacilities/getActiveAdminFacility'];
    }

    get showMoreVisibility() {
        return this.activeFacility.description.length > 140;
    }

    get getAvailableForBooking() {
        return this.availableForBooking;
    }

    public seeOnCalendar(facilityId: number) {
        this.$store.commit(Mutations.SET_FACILITY_FORM_MODE, 'calendar');
        this.$store.commit(Mutations.SET_ACTIVE_ADMIN_FACILITY, facilityId);
        this.$store.dispatch(Actions.FETCH_ACTIVE_ADMIN_FACILITY_BOOKINGS, facilityId);
    }

    public deleteActiveFacility(facilityId: number, facilityName: string) {
        this.$store.commit(Mutations.SET_CONFIRM_POPUP_DATA, {
            confirmAction: 'SharedFacilities/DELETE_ADMIN_ACTIVE_FACILITY',
            confirmActionData: { facilityId },
            confirmQuestionText: this.$t('confirmation.are-you-sure-you-want-to-delete-this-facility', 'Are you sure you want to delete this facility?'),
            confirmInfoText: facilityName,
            confirmButton: this.$t('forms.delete', 'Delete'),
            confirmIconVisibility: true,
            confirmIcon: 'fa-trash',
            confirmHeaderText: this.$t('general.delete-facility', 'Delete facility'),
            confirmButtonClass: 'hococo-close-form-btn',
        });
    }

    public secondaryPhotos(photos: any) {
        const secondaries = cloneDeep(photos);
        secondaries.shift();
        return secondaries;
    }

    public setAttacheSrc(src: string)  {
        return 'data:image/png;charset=utf-8;base64,' + src;
    }

    public showFullInfo() {
        this.fullInfoVisibility = !this.fullInfoVisibility;
    }

    @Watch('activeFacility')
    public activeFacilityChanged() {
        this.availableForBooking = this.activeFacility.status;
    }

    @Watch('getAvailableForBooking')
    public checkvailableForBooking() {
        if (this.activeFacility.status !== this.availableForBooking) {
            this.$store.dispatch(Actions.CHANGE_ACTIVE_ADMIN_FACILITY_AVAILABLE, {available: this.availableForBooking, facilityId: this.activeFacility.id});
        }
    }

    public created() {
        this.availableForBooking = this.activeFacility.status;
    }
}
